import { FaStar } from "react-icons/fa";
import { motion } from "framer-motion";
import AnimatedTitle from "../../../components/AnimatedTitle";

const data = [
  {
    id: 1,
    image: "/tool-1.png",
    review:
      "Datagenx not only establishes connections using prompts but also provides helpful guidance and corrective suggestions whenever issues occur during the process.",
  },
  {
    id: 2,
    image: "/tool-3.png",
    review:
      "I tried the DATAGENX preview, and the experience was smooth and easy. The tool guides the user step by step, making it intuitive even for first-time users. With more supported transformations, it could become a highly useful tool for dbt-focused teams.",
  },
];

const ReviewsSection = () => {
  return (
    <>
      <div className="reviews-container mx-auto px-4 md:px-6 lg:px-8 py-24">
        <AnimatedTitle>
          <h2
            className="text-3xl font-semibold text-center mx-auto mb-10"
            style={{ color: "var(--color-primary)" }}
          >
            Users Reviews
          </h2>
        </AnimatedTitle>

        <motion.div
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          viewport={{ once: true, amount: 0.5 }}
        >
          <section className="reviews-wrapper">
            {data.map((item, idx) => (
              <div key={item.id} className="review-card-item">
                <div className="review-logo-box">
                  <img
                    src={item.image}
                    alt="Company Logo"
                    className="review-img"
                    style={{
                      width: idx === 1 ? "95px" : "140px",
                    }}
                  />
                </div>

                <motion.div
                  className="stars-row"
                  initial="hidden"
                  whileInView="show"
                  viewport={{ once: true, amount: 0.5 }}
                  variants={{
                    hidden: { opacity: 0 },
                    show: {
                      opacity: 1,
                      transition: {
                        delayChildren: 0.8,
                        staggerChildren: 0.15,
                      },
                    },
                  }}
                >
                  {[...Array(5)].map((_, i) => (
                    <motion.div
                      key={i}
                      variants={{
                        hidden: { opacity: 0, scale: 0, y: 10 },
                        show: {
                          opacity: 1,
                          scale: 1,
                          y: 0,
                          transition: { type: "spring", stiffness: 200 },
                        },
                      }}
                    >
                      <FaStar />
                    </motion.div>
                  ))}
                </motion.div>

                <p
                  className="review-text-content"
                  style={{ fontSize: idx === 0 ? "19px" : "" }}
                >
                  "{item.review}"
                </p>
              </div>
            ))}
          </section>
        </motion.div>
      </div>

      <style jsx>{`
        .reviews-wrapper {
          display: flex;
          flex-wrap: wrap;
          gap: 30px;
          justify-content: center;
        }

        .review-card-item {
          flex: 1 1 100%;
          max-width: 500px;
          border-radius: 24px;
          padding: 40px 32px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          text-align: left;

          background: linear-gradient(
            -20deg,
            #715dda 10%,
            #a2f2ea 70%,
            #ffffff 100%
          );

          box-sizing: border-box;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
        }

        .review-logo-box {
          border-radius: 12px;
          display: flex;
          align-items: center;
          margin-bottom: 25px;
        }

        .review-img {
          height: auto;
          object-fit: contain;
        }

        .stars-row {
          display: flex;
          gap: 4px;
          color: #ffcc00;
          font-size: 18px;
          margin-bottom: 15px;
        }

        .review-text-content {
          font-style: italic;
          margin: 0;
        }

        @media (min-width: 768px) {
          .review-card-item {
            flex: 0 1 calc(45% - 15px);
          }
        }

        @media (min-width: 1200px) {
          .review-card-item {
            flex: 0 1 480px;
          }
        }
      `}</style>
    </>
  );
};

export default ReviewsSection;
